import React, { Component } from 'react';
import { Row, Col, Spin, Select } from 'antd';
import { inject, observer } from 'mobx-react';
import "./index.scss";
import Rank from './rank';
import Chart from './chart';
import Comments from './comments';
import { runInAction } from 'mobx';

const { Option } = Select;

@inject('store')
@observer
class index extends Component {

    render() {
        const { loading, } = this.props.store.criticism;
        const { rivalData, rival } = this.props.store.groupChannels;
        return (
            <div className='groupOfChannels'>
                <div className='title'>Online Travel Agency 网络平台</div>
                {rivalData.length > 0 && <div className="rival">
                    <span className="name">竞争对手</span>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="请选择竞争对手"
                        value={rival || undefined}
                        onChange={v => {
                            runInAction(() => {
                                this.props.store.groupChannels.rival = v
                            })
                            this.props.store.groupChannels.getDataCount(v);
                            this.props.store.groupChannels.getData('5.0', '', '', 1, '1', v);
                            this.props.store.criticism.getData(v);
                        }}
                    >
                        {
                            rivalData.map(x => <Option key={x.name}>{x.name}</Option>)
                        }
                    </Select>
                </div>}
                <Spin spinning={loading} tip="加载中。。。">
                    <Row gutter={40}>
                        <Col span={7}><Rank history={this.props.history} /></Col>
                        <Col span={17}><Chart /></Col>
                    </Row>
                </Spin>
                <Comments />
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/guestRating/channels/index.js